export default __webpack_public_path__ + "static/media/ca-qc.8978d77e.svg";